import React, { useState } from 'react';
import { string, shape, arrayOf } from 'prop-types';

import { ALL_TYPE_KEY } from 'helpers/contentfulTypes';

import Button from 'components/buttons/Button';
import CTA from 'components/CTA';
import Featured from 'components/Featured';
import Filters from 'components/Filters';
import Footer from 'components/Footer';
import Layout from 'components/Layout';
import Navbar from 'components/Navbar/Navbar';
import PageLink from 'components/PageLink';

import {
  ButtonWrapper,
  Byline,
  Container,
  Grid,
  Header,
  Headline,
} from 'components/IndexStyles';

const publishedAtSortFunction = (pageOne, pageTwo) =>
  new Date(pageTwo.node.publishedAt) - new Date(pageOne.node.publishedAt);

const IndexPage = ({ data }) => {
  const [pageFilter, setPageFilter] = useState(ALL_TYPE_KEY);
  const [showLimitedPages, setShowLimitedPages] = useState(true);
  const pages = data.allContentfulPage.edges
    .sort(publishedAtSortFunction)
    .filter(page => {
      if (pageFilter === ALL_TYPE_KEY) return true;
      return pageFilter === page.node.content[0].contentfulType;
    });
  const limitPages = pages.length > 6;

  const LimitedPages = () =>
    pages
      .slice(0, 6)
      .map(page => (
        <PageLink className="item" key={page.node.slug} page={page.node} />
      ));

  const AllPages = () =>
    pages.map(page => (
      <PageLink className="item" key={page.node.slug} page={page.node} />
    ));

  return (
    <Layout title="Resources">
      <Header>
        <Navbar createAccount />
        <Headline>
          <span>Resources</span>
        </Headline>
        <Byline>The expertise you need to level up your workforce.</Byline>
      </Header>
      <Container>
        <Featured />
        <Filters setPageFilter={setPageFilter} />
        <Grid>
          {limitPages && showLimitedPages ? <LimitedPages /> : <AllPages />}
        </Grid>
        {limitPages && showLimitedPages && (
          <ButtonWrapper>
            <Button
              as="button"
              bg={waffles => waffles.theme.colors.white}
              borderColor={waffles => waffles.theme.colors.white}
              boxShadow={waffles => waffles.theme.shadows.sm}
              hoverTextColor={waffles => waffles.theme.colors.primary}
              onClick={() => setShowLimitedPages(!showLimitedPages)}
              textColor={waffles => waffles.theme.colors.greyDark}
            >
              Show More
            </Button>
          </ButtonWrapper>
        )}
      </Container>
      <CTA />
      <Footer />
    </Layout>
  );
};

export const query = graphql`
  query allPageQuery {
    allContentfulPage(filter: { discoverable: { eq: true } }) {
      edges {
        node {
          publishedAt
          title
          slug
          shortDescription
          content {
            contentfulType: __typename
            ... on ContentfulWhitepaper {
              graphic {
                localFile {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

IndexPage.propTypes = {
  data: shape({
    allContentfulPage: shape({
      edges: arrayOf(
        shape({
          node: shape({
            publishedAt: string.isRequired,
            shortDescription: string.isRequired,
            title: string.isRequired,
            slug: string.isRequired,
            content: arrayOf(
              shape({
                contentfulType: string.isRequired,
                graphic: shape({
                  localFile: shape({
                    url: string,
                  }),
                }),
              })
            ),
          }),
        })
      ),
    }),
  }).isRequired,
};

export default IndexPage;
